var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconCertifiedGreen(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.134,
    height: 17.912,
    viewBox: "0 0 15.134 17.912",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1369",
    "data-name": "Group 1369",
    transform: "translate(-1742.099 -459.644)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_668",
    "data-name": "Path 668",
    d: "M1743.66,465.065v-3.36a1.558,1.558,0,0,1,1.556-1.562h10.06a1.558,1.558,0,0,1,1.559,1.559v11.629a1.559,1.559,0,0,1-1.559,1.559h-5.494",
    transform: "translate(-0.101 0)",
    fill: "none",
    stroke: "#2ebfa5",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_228",
    "data-name": "Line 228",
    x2: 4.146,
    transform: "translate(1750.698 465.82)",
    fill: "none",
    stroke: "#2ebfa5",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_666",
    "data-name": "Path 666",
    d: "M1748.5,473.671v4.717l-2.117-1.532-2.056,1.532v-4.717",
    transform: "translate(-0.162 -1.828)",
    fill: "#fff",
    stroke: "#2ebfa5",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_155",
    "data-name": "Ellipse 155",
    cx: 3.695,
    cy: 3.695,
    r: 3.695,
    transform: "translate(1742.599 465.821)",
    fill: "#2ebfa5",
    stroke: "#2ebfa5",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_229",
    "data-name": "Line 229",
    x2: 2.72,
    transform: "translate(1752.124 468.831)",
    fill: "none",
    stroke: "#2ebfa5",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_230",
    "data-name": "Line 230",
    x2: 9.393,
    transform: "translate(1745.45 462.809)",
    fill: "none",
    stroke: "#2ebfa5",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_231",
    "data-name": "Line 231",
    x2: 2.068,
    transform: "translate(1752.776 471.843)",
    fill: "none",
    stroke: "#2ebfa5",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_667",
    "data-name": "Path 667",
    d: "M1745.851,471.939l-.48-.536q-.454-.5-.9-1.01a.5.5,0,0,1,.323-.833.483.483,0,0,1,.421.174l.66.736.063.068.074-.061,1.816-1.617a.5.5,0,1,1,.706.7.372.372,0,0,1-.032.031q-1.307,1.168-2.618,2.333Z",
    transform: "translate(-0.165 -0.817)",
    fill: "#fff"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCertifiedGreen);
export default __webpack_public_path__ + "static/media/icon-certified-green.816f532a.svg";
export { ForwardRef as ReactComponent };